<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <v-layout class="section-header" row wrap align-center justify-center>
        <v-flex xs12 md4>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-ruler-combined</v-icon>
              Avaliações
            </h1>
          </v-layout>
        </v-flex>
        <v-flex xs12 md8>
          <v-layout row wrap justify-end align-center>
            <!-- <v-text-field v-model="search" class="search-input" label="Buscar"
              append-icon="fal fa-search"></v-text-field> -->
            <a href="#" class="link-info mx-4">
              <v-icon small>fal fa-info-circle</v-icon> Saiba como fazer a sua avaliação
            </a>
            <v-btn round depressed large color="success" dark
              v-modal-trigger="'showNewEvaluation'" v-if="evaluations.length && healthCard">
              Nova avaliação
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <health-card-notify v-if="!healthCard"></health-card-notify>
    <first-evaluation-notify v-if="!evaluations.length && healthCard"></first-evaluation-notify>

    <evaluations-list v-if="evaluations.length" :evaluations="evaluations"></evaluations-list>
    <health-card v-if="healthCard" :healthCard="healthCard"></health-card>

    <new-evaluation></new-evaluation>
  </v-layout>
</template>

<script>
// import router from '@/router'
import axios from 'axios'
import UserEvaluationsList from '@/components/user/evaluations/UserEvaluationsList'
import UserHealthCard from '@/components/user/evaluations/UserHealthCard'
import UserFirstEvaluationNotify from '@/components/user/evaluations/UserFirstEvaluationNotify'
import UserHealthCardNotify from '@/components/user/evaluations/UserHealthCardNotify'
import UserNewEvaluation from '@/components/user/evaluations/UserNewEvaluation'
import EventBus from '@/event-bus'

export default {
  data: () => ({
    user: JSON.parse(localStorage.getItem('currentUser')),
    healthCard: null,
    evaluations: []
  }),

  methods: {
    loadHealthCard () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      let path = `${API.userHealthyCards}/users/${this.user._id}`

      axios.get(path).then(response => {
        if (response.data.healthy_card) { this.healthCard = response.data.healthy_card }
        EventBus.$emit('appLoading', false)
        this.loadEvaluations()
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar o questionário de saúde',
          color: 'error'
        })
        EventBus.$emit('appLoading', false)
      })
    },

    loadEvaluations () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      let path = `${API.userEvaluations}/users/${this.user._id} `

      axios.get(path).then(response => {
        if (response.data.evaluations) { this.evaluations = response.data.evaluations }
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar as avaliações',
          color: 'error'
        })
        EventBus.$emit('appLoading', false)
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadUserEvaluations')
  },

  created () {
    this.loadHealthCard()
    EventBus.$on('loadUserEvaluations', this.loadHealthCard)
    EventBus.$on('loadUserEvaluations', this.loadEvaluations)
  },

  components: {
    'evaluations-list': UserEvaluationsList,
    'health-card': UserHealthCard,
    'first-evaluation-notify': UserFirstEvaluationNotify,
    'health-card-notify': UserHealthCardNotify,
    'new-evaluation': UserNewEvaluation
  }
}
</script>

<style>
.v-expansion-panel {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserEvaluations.vue